import {h, Fragment} from "preact"
import { defaultConfig } from "../config"
import { useAppState, HistoryElement, AutocompleteElement, useCurrencyFormatting } from "@nosto/preact"
import { useEffect, useState, useRef } from "preact/hooks"
import {closeSearchOverlay, fetchPopularProducts, formatShopifyMoney } from "../helpers"

import AutocompleteProduct from "./AutocompleteProduct"

export default function History() {
    const { historyItems } = useAppState()
    const { format } = useCurrencyFormatting();
    const [products, setProducts] = useState([]);
    const autocompleteRef = useRef(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await fetchPopularProducts();
                setProducts(res);
            } catch (error) {
                console.error('Error fetching popular products:', error);
            }
        };
    
        fetchData();
    }, []);

    useEffect(() => {
        if(!autocompleteRef.current) return;

        const handleClick = e => e.target.closest('.ns-autocomplete-element') && closeSearchOverlay();

        autocompleteRef.current.addEventListener('click', handleClick);
        return () => autocompleteRef.current.removeEventListener('click', handleClick);
    }, [])

    return (
        // ; display: none; style="top: 140px;"
        <div class="ns-premodal ns-fixed ns-flex-column ns-flex-sm-row ns-align-items-start ns-background-white ns-border-box ns-mx-auto" data-nosto-element="autocomplete" ref={autocompleteRef}>
              <div class="ns-close">&times;</div>
              <div class="ns-w-100 ns-mt-sm-auto">
                  <div class="ns-d-flex ns-flex-column ns-flex-sm-row" id="nosto-autocomplete-box">
                      <div class="ns-autocomplete-keywords ns-d-flex ns-flex-column ns-col-12 ns-col-sm-2">
                          <div class="ns-autocomplete-header ns-font-bold">Popular Searches</div>
                          <div class="ns-d-flex ns-flex-column ns-pop-suggestions">
                                {window.nostoSearch?.topSearches?.length > 0 && 
                                    window.nostoSearch.topSearches.map((search) => (
                                        <AutocompleteElement
                                            key={search?.text}
                                            hit={{
                                                keyword: search.text,
                                                _redirect: search.url,
                                                url: search.url ?? null
                                            }}
                                            class="ns-clickable ns-py-2 ns-px-4 ns-text-no-underline"
                                        >
                                            <span>{search?.text}</span>
                                        </AutocompleteElement>
                                    ))
                                }
                          </div>
                          <div class="ns-autocomplete-header ns-font-bold ns-mt-4">
                            Recent Searches
                        </div>
                        <div>
                            {historyItems?.slice(0, defaultConfig.historySize).map(item => (
                                <HistoryElement query={{ query: item }}>
                                    {/* ns-d-flex ns-flex-column ns-justify-content-between */}
                                    <div class="ns-autocomplete-element ns-clickable ns-py-2 ns-px-4 ns-text-no-underline">
                                        {item}
                                    </div>
                                </HistoryElement>
                            ))}
                        </div>    
                      </div>
                      {/* Category block */}
                      <div class="ns-autocomplete-categories ns-d-flex ns-flex-column ns-col-12 ns-col-sm-2">
                          <div class="ns-autocomplete-header ns-font-bold">Category</div>
                          <div class="ns-d-flex ns-flex-column ns-pop-suggestions ns-top-categories">
                              {window.nostoSearch?.topCollections?.length > 0 && 
                                window.nostoSearch.topCollections.map((collection) => (
                                    <AutocompleteElement
                                        key={collection?.text}
                                        hit={{
                                            keyword: collection.text,
                                            _redirect: collection.url,
                                            url: collection.url ?? null
                                        }}
                                        class="ns-clickable ns-py-2 ns-px-4 ns-text-no-underline"
                                    >
                                        <span>{collection?.text}</span>
                                    </AutocompleteElement>
                                ))
                              }
                          </div>
                          <div class="ns-autocomplete-header ns-font-bold ns-mt-4">Color</div>
                            <div class="ns-d-flex ns-flex-column facets__list--color ns-top-colors ns-w-100 ns-mb-4" style="position: unset;">
                                {window.nostoSearch?.topColors?.length > 0 && 
                                    window.nostoSearch.topColors.map((color) => {
                                        let formattedColor;
                                        let parts = color.split(" ");
                                        if(parts?.length > 1){
                                            formattedColor = parts?.join("+");
                                        } else {
                                            formattedColor = color;
                                        }
                                        const isBlackOrWhite = color === "Black" || color === "White";
                                        const sanitizedValue = color.toLowerCase().replaceAll(" ", "-");
                                        const hexColor = color === "Black" ? "#000000" : "#FFFFFF";
                                        const labelStyle = isBlackOrWhite
                                            ? `background-color: ${hexColor};`
                                            : `background-size: cover; background-image: url(https://cdn.shopify.com/s/files/1/0158/2548/files/${sanitizedValue}.jpg)`;
                                        
                                        return (
                                            <AutocompleteElement 
                                                key={color}
                                                hit={{ keyword: color }}
                                                class="ns-clickable ns-py-2 ns-px-4 ns-text-no-underline"
                                            >
                                                <li class="list-menu__item facets__item" style={{display: "inline-flex"}}>
                                                    <input type="checkbox" />
                                                    <label class="facet-checkbox" style={labelStyle}>
                                                        <span class="visually-hidden"></span>
                                                    </label>
                                                    {color} 
                                                </li>
                                            </AutocompleteElement>
                                        )
                                    }
                                )}
                            </div>
                      </div>
                      
                      {/* ================ */}
                      <div class="ns-autocomplete-products ns-d-flex ns-flex-column ns-flex-grow-1">
                          <div class="ns-autocomplete-header ns-font-bold">Recommended for you</div>
                          <div class="nosto-products-container">
                              {products?.length > 0 && products.map((product) => (
                                    <AutocompleteProduct
                                        key={product.productId}
                                        hit={product}
                                    />
                                )
                              )}
                          </div>
                      </div>
                  </div>
              </div>
            </div>
    )
}
